import React, { Component } from 'react';
import ReadDetail from 'nbugs-pc-read';
import { ENV } from '../../../../services/utils';
import Container from '../../../../components/Container';
import { GetQueryString } from '../../../../utils/common';

class Index extends Component {
  render() {
    const msgId = GetQueryString('msgId');
    return (
      <Container breStates version={2} isPathParams>
        <ReadDetail
          className="nbugs-component-read"
          msgId={msgId}
          btnExportText='导出明细'
          APIEnv={ENV}
        />
      </Container>
    );
  }
}

export default Index;
